import { render } from "./addguestr.vue?vue&type=template&id=8411b986&scoped=true"
import script from "./addguestr.vue?vue&type=script&lang=js"
export * from "./addguestr.vue?vue&type=script&lang=js"

import "./addguestr.vue?vue&type=style&index=0&id=8411b986&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8411b986"

export default script